/**
 * Get UTM data from sozvuchno_utm cookie
 * @returns {Object|null} Parsed UTM data or null if not found
 */
export const getUtmData = () => {
  const cookieMatch = document.cookie.match(/sozvuchno_utm=([^;]+)/);
  
  if (!cookieMatch || !cookieMatch[1]) {
    return null;
  }

  try {
    const decodedValue = decodeURIComponent(cookieMatch[1]);
    return JSON.parse(decodedValue);
  } catch (error) {
    console.error('Failed to parse sozvuchno_utm cookie:', error);
    return null;
  }
};
